var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e4e3e5",
    d: "M15 1.5C15 2.328 11.642 3 7.5 3S0 2.328 0 1.5 3.358 0 7.5 0 15 .672 15 1.5",
    transform: "translate(1 15)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363954",
    d: "M10.89 15.831c-.043 0-.135 0-.276-.014a7.892 7.892 0 0 1-2.776-.862 14.552 14.552 0 0 1-4.489-3.721C.539 7.886-.39 5.491.143 2.97A4.131 4.131 0 0 1 1.842.389 1.655 1.655 0 0 1 2.9 0c.046 0 .091 0 .138.005h.005a1.566 1.566 0 0 1 1.065.55L6.1 2.93a1.613 1.613 0 0 1-.227 2.262l-.681.569a.416.416 0 0 0-.106.5A10.006 10.006 0 0 0 6.52 8.576a9.909 9.909 0 0 0 2.033 1.817.409.409 0 0 0 .2.074h.009a.428.428 0 0 0 .292-.094l.687-.573a1.655 1.655 0 0 1 1.059-.388c.052 0 .1 0 .145.006a1.559 1.559 0 0 1 1.064.547L14 12.341a1.612 1.612 0 0 1-.227 2.262 4.177 4.177 0 0 1-2.841 1.228zM2.9.936a.7.7 0 0 0-.453.17 3.245 3.245 0 0 0-1.389 2.053c-.464 2.209.407 4.374 3.007 7.472 3.087 3.68 5.855 4.186 6.629 4.253a2.011 2.011 0 0 0 .2.012 3.312 3.312 0 0 0 2.275-1.01.675.675 0 0 0 .111-.941l-1.99-2.377a.644.644 0 0 0-.431-.217h-.014a.735.735 0 0 0-.5.167l-.683.572a1.35 1.35 0 0 1-.864.315l-.126-.005a1.348 1.348 0 0 1-.659-.24A11.174 11.174 0 0 1 5.8 9.178a10.911 10.911 0 0 1-1.56-2.52 1.351 1.351 0 0 1 .353-1.615l.679-.569a.672.672 0 0 0 .111-.941L3.391 1.157a.62.62 0 0 0-.428-.218L2.908.833 2.9.935z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3bf79ea3f0ec60ef6242075955dc9f04.svg";
export { ForwardRef as ReactComponent };